// extracted by mini-css-extract-plugin
export default {"heading":"Sv-z","corrected":"Tv-z","redirectVerbiageContainer":"Uv-z","redirectVerbiageText":"Vv-z"};